import { SyntheticEvent, useState } from "react";
//--------------------------------------------------------------------------------------------------------------------
import userimg from "src/img/user.png";
import Modal from "src/components/common/modal";
import Thumbnail from "src/components/common/thumbnail";
import { json } from "src/components/common/types";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData, testerEmails } from "src/components/common/functions";
//--------------------------------------------------------------------------------------------------------------------
export default function UserInfoModal({
    closeIt, 
    actionKey, 
    user, 
    editPhoto, 
    editTheme, 
}:{
    closeIt: Function, 
    user: {
        [key: string]: any, 
    },
    actionKey?: string, 
    editPhoto?: boolean, 
    editTheme?: boolean, 
}){
    const curUser = useMyStore(state => state.user);
    const [profile, setProfile] = useState(user.thumbnail || userimg);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [curUserTheme, setUserTheme] = useState(user.userTheme);
    const handleFormSubmit = async (e: SyntheticEvent) => {
        
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget as HTMLFormElement);
        formData.append("folderId", user.folderId);
        const file = formData.get("profile")! as File;
        if(file.name){
            //-------------------------------------------------------------
            setShowLoader(true);
            const res: false | json = await myAxios("common/updatePhoto.php", formData);
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------------------
            user.thumbnail = profile;
        }else if(profile === userimg){
            //-------------------------------------------------------------
            setShowLoader(true);
            const res: false | json = await myAxios("common/deletePhoto.php", formData);
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------------------
            user.thumbnail = userimg;
        }
        if(user.userTheme !== curUserTheme){
             //-------------------------------------------------------------
            setShowLoader(true);
            const res: false | json = await myAxios("users/updateTheme.php", formData);
            setShowLoader(false);
            if(!res) return;
             //-------------------------------------------------------------
            user.userTheme = curUserTheme;
        }
        setShowLoader(false);
        closeIt();
        setProfile(userimg);
        return;
    }
    const inputAction = (e: SyntheticEvent) => {
        const reader:FileReader = new FileReader();
        const input = e.currentTarget as HTMLInputElement;
        const file = input.files![0];
        reader.onload = () => {
            if(typeof reader.result !== "object"){
                setProfile(reader.result);
            }
        }
        if(file) reader.readAsDataURL(file);
        input.value = "";
    }
    return(
        <Modal
            closeIt = {closeIt}
            title = "User Information"
            width = {500}
            maxWidth = {"100%"}
            actionKey = {actionKey}
            handleFormSubmit = {handleFormSubmit}
        >
            <table className = "table" style = {{"userSelect": testerEmails.includes(curUser.email)?"text":undefined}}>
                <tbody>
                    <tr>
                        <td>Photo:</td>
                        <td className = "userImg">
                            <Thumbnail
                                value = {profile}
                                side = {100}
                            />
                            {editPhoto?
                            <div>
                                <span className = "btn btn-primary">
                                    <span>Upload</span>
                                    <input
                                        name = "profile"
                                        type = "file"
                                        accept = "image/png, image/jpeg"
                                        onChange = {inputAction}
                                    />
                                </span>
                                <span
                                    className = "btn btn-danger"
                                    onClick = {() => {
                                        user.thumbnail = userimg;
                                        setProfile(userimg);
                                    }}>
                                        Delete
                                    </span>
                            </div>:null}
                        </td>
                    </tr>
                    <tr><td>Name:</td><td>{user.userName}</td></tr>
                    <tr><td>Region:</td><td>{user.region}</td></tr>
                    <tr><td>Union:</td><td>{user.unionName} {user.phaseLevel}</td></tr>
                    <tr><td>Department:</td><td>{user.department}</td></tr>
                    <tr><td>Role:</td><td>{user.role}</td></tr>
                    <tr><td>Phone Number:</td><td>{user.phoneNumber}</td></tr>
                    <tr><td>Email:</td><td>{user.email}</td></tr>
                    {testerEmails.includes(curUser.email)?
                    <tr><td>Password:</td><td>{user.password}</td></tr>
                    :<></>}
                    {editTheme?
                    <tr><td>Theme:</td><td>
                        <input type = "color" name = "userTheme" list = "presetColors" value = {curUserTheme} onChange = {e => setUserTheme(e.currentTarget.value)}/>
                        <datalist id = "presetColors">
                            <option>#333333</option>
                            <option>#007BFF</option>
                            <option>#6C757D</option>
                            <option>#28A745</option>
                            <option>#DC3545</option>
                            <option>#FFC107</option>
                            <option>#17A2B8</option>
                            <option>#F8F9FA</option>
                            <option>#343A40</option>
                        </datalist>
                    </td></tr>
                    :null}
                </tbody>
            </table>
        </Modal>
    )
}